import { PageBanner } from '../../../services';
import { ICarouselItem } from '../models';

export function mapToBannersItem(b: PageBanner): ICarouselItem {
  return {
    desktopLogo: b.imageLink,
    mobileLogo: b.mobileImageLink,
    redirectUrl: b.redirectUrl,
    alt: b.imageName,
  };
}
